import { NavLink } from "react-router-dom";
import tw from "twin.macro";

export const PrimaryLink = tw(NavLink)`cursor-pointer font-serif font-bold text-primary-500 border-b-2 border-transparent hocus:border-primary-500 hocus:text-primary-800 transition duration-300`;

export const PrimaryButtonLink = tw(NavLink)`text-sm md:text-lg cursor-pointer font-serif uppercase px-5 md:px-10 py-3 rounded-full bg-primary-500 text-white hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300 font-light`;
